import { Link } from 'react-router-dom';

const Navbar = () => {
    return (
        <nav>
            <Link to='/' href='/'></Link>
            <Link to='/about' href='/about'></Link>
            <Link to='/portfolio' href='/portfolio'></Link>
            <Link to='/service' href='/service'></Link>
            <Link to='/contact' href='/contact'></Link>
            <Link to='/products' href='/products'></Link>
            <Link to='/dis' href='/dis'></Link>
            <Link to='/tc' href='/tc'></Link>
            <Link to='/ref' href='/ref'></Link>
            <Link to='/conf' href='/conf'></Link>
            <Link to='/pri' href='/pri'></Link>
            <Link to="/form" href='/form'></Link>
        </nav>
    );
}

export default Navbar;
